import {
  GET_PATIENTS_SUCCESS,
  GET_PATIENTS_FAIL,
  GET_PATIENTS_DETAILS_SUCCESS,
  GET_PATIENTS_DETAILS_FAIL,
  ADD_PATIENTS_SUCCESS,
  ADD_PATIENTS_FAIL,
  UPDATE_PATIENTS_SUCCESS,
  UPDATE_PATIENTS_FAIL,
  DELETE_PATIENTS_SUCCESS,
  DELETE_PATIENTS_FAIL,
  RESET_PATIENTS_STATE,
} from "./actionTypes"

const INIT_STATE = {
  patients: [],
  patientsDetails: [],
  addPatients: [],
  editPatients: [],
  delPatients: [],
}

const Patients = (state = INIT_STATE, action) => {

  switch (action.type) {
    case GET_PATIENTS_SUCCESS:
      return {
        ...state,
        patients: action.payload,
      }

    case GET_PATIENTS_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case GET_PATIENTS_DETAILS_SUCCESS:
      return {
        ...state,
        patientsDetails: action.payload,
      }

    case GET_PATIENTS_DETAILS_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case ADD_PATIENTS_SUCCESS:
      return {
        ...state,
        patientsDetails: action.payload.data,
        addPatients: action.payload,
      }

    case ADD_PATIENTS_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case UPDATE_PATIENTS_SUCCESS:
      return {
        ...state,
        patientsDetails: action.payload.data,
        editPatients: action.payload,
      }

    case UPDATE_PATIENTS_FAIL:
      return {
        ...state,
        error: action.payload,
        editPatients: action.payload,
      }
    case DELETE_PATIENTS_SUCCESS:
      return {
        ...state,
        delPatients: action.payload,
      }

    case DELETE_PATIENTS_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case RESET_PATIENTS_STATE:
      return {
        ...state,
        addPatients: [],
        patientsDetails: [],
        patients: [],
        editPatients: [],
        delPatients: [],
        error:[],
      }
    default:
      return state
  }
}

export default Patients
